"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetViewFields = void 0;
const BasicFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/BasicFieldType"));
const StaticFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/StaticFieldType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const ViewFieldKey_1 = __importDefault(require("../ViewFieldKey"));
exports.AssetViewFields = {
    [ViewFieldKey_1.default.ASSET_WHERE]: {
        key: ViewFieldKey_1.default.ASSET_WHERE,
        fieldType: BasicFieldType_1.default.OPDEF_WHERE,
        label: () => lib_i18n_1.default.t('where'),
        allLabel: () => lib_i18n_1.default.t('anywhere'),
        emptyLabel: () => lib_i18n_1.default.t('anywhere'),
        description: () => lib_i18n_1.default.t('where-description'),
        sortable: false,
        width: 150,
        gqlFields: 'placeTags, placesSelectedByTag, placesSelectedByParent, places { id, title, timezone }',
    },
    [ViewFieldKey_1.default.ASSET_TYPE]: {
        key: ViewFieldKey_1.default.ASSET_TYPE,
        fieldType: StaticFieldType_1.default.ASSET_TYPE,
        propertyName: 'assetType',
        label: () => lib_i18n_1.default.t('asset-type'),
        sortable: false,
        width: 160,
        gqlFields: 'assetType',
    },
    [ViewFieldKey_1.default.ASSET_MANUFACTURER]: {
        key: ViewFieldKey_1.default.ASSET_MANUFACTURER,
        fieldType: BasicFieldType_1.default.STRING,
        propertyName: 'manufacturer',
        label: () => lib_i18n_1.default.t('manufacturer'),
        sortable: false,
        width: 100,
        gqlFields: 'manufacturer',
    },
    [ViewFieldKey_1.default.ASSET_MODEL]: {
        key: ViewFieldKey_1.default.ASSET_MODEL,
        fieldType: BasicFieldType_1.default.STRING,
        propertyName: 'model',
        label: () => lib_i18n_1.default.t('model'),
        sortable: false,
        width: 100,
        gqlFields: 'model',
    },
    [ViewFieldKey_1.default.ASSET_SERIALNO]: {
        key: ViewFieldKey_1.default.ASSET_SERIALNO,
        fieldType: BasicFieldType_1.default.STRING,
        propertyName: 'serialNo',
        label: () => lib_i18n_1.default.t('serial-number'),
        sortable: false,
        width: 100,
        gqlFields: 'serialNo',
    },
    [ViewFieldKey_1.default.ASSET_LASTSERVICEDATE]: {
        key: ViewFieldKey_1.default.ASSET_LASTSERVICEDATE,
        fieldType: BasicFieldType_1.default.DATE,
        propertyName: 'lastServiceDate',
        label: () => lib_i18n_1.default.t('last-service'),
        sortable: false,
        width: 100,
        gqlFields: 'lastServiceDate',
    },
    [ViewFieldKey_1.default.ASSET_CUSTOMFIELD_0]: {
        key: ViewFieldKey_1.default.ASSET_CUSTOMFIELD_0,
        fieldType: BasicFieldType_1.default.STRING,
        propertyName: 'customField0',
        label: () => lib_i18n_1.default.t('last-service'),
        sortable: false,
        width: 100,
        gqlFields: 'customField0',
    },
    [ViewFieldKey_1.default.ASSET_CUSTOMFIELD_1]: {
        key: ViewFieldKey_1.default.ASSET_CUSTOMFIELD_1,
        fieldType: BasicFieldType_1.default.STRING,
        propertyName: 'customField1',
        label: () => lib_i18n_1.default.t('last-service'),
        sortable: false,
        width: 100,
        gqlFields: 'customField1',
    },
    [ViewFieldKey_1.default.ASSET_CUSTOMFIELD_2]: {
        key: ViewFieldKey_1.default.ASSET_CUSTOMFIELD_2,
        fieldType: BasicFieldType_1.default.STRING,
        propertyName: 'customField2',
        label: () => lib_i18n_1.default.t('last-service'),
        sortable: false,
        width: 100,
        gqlFields: 'customField2',
    },
    [ViewFieldKey_1.default.ASSET_CUSTOMFIELD_3]: {
        key: ViewFieldKey_1.default.ASSET_CUSTOMFIELD_3,
        fieldType: BasicFieldType_1.default.STRING,
        propertyName: 'customField3',
        label: () => lib_i18n_1.default.t('last-service'),
        sortable: false,
        width: 100,
        gqlFields: 'customField3',
    },
    [ViewFieldKey_1.default.ASSET_CUSTOMFIELD_4]: {
        key: ViewFieldKey_1.default.ASSET_CUSTOMFIELD_4,
        fieldType: BasicFieldType_1.default.STRING,
        propertyName: 'customField4',
        label: () => lib_i18n_1.default.t('last-service'),
        sortable: false,
        width: 100,
        gqlFields: 'customField4',
    },
    [ViewFieldKey_1.default.ASSET_CUSTOMFIELD_5]: {
        key: ViewFieldKey_1.default.ASSET_CUSTOMFIELD_5,
        fieldType: BasicFieldType_1.default.STRING,
        propertyName: 'customField5',
        label: () => lib_i18n_1.default.t('last-service'),
        sortable: false,
        width: 100,
        gqlFields: 'customField5',
    },
    [ViewFieldKey_1.default.ASSET_CUSTOMFIELD_6]: {
        key: ViewFieldKey_1.default.ASSET_CUSTOMFIELD_6,
        fieldType: BasicFieldType_1.default.STRING,
        propertyName: 'customField6',
        label: () => lib_i18n_1.default.t('last-service'),
        sortable: false,
        width: 100,
        gqlFields: 'customField6',
    },
    [ViewFieldKey_1.default.ASSET_CUSTOMFIELD_7]: {
        key: ViewFieldKey_1.default.ASSET_CUSTOMFIELD_7,
        fieldType: BasicFieldType_1.default.STRING,
        propertyName: 'customField7',
        label: () => lib_i18n_1.default.t('last-service'),
        sortable: false,
        width: 100,
        gqlFields: 'customField7',
    },
    [ViewFieldKey_1.default.ASSET_CUSTOMFIELD_8]: {
        key: ViewFieldKey_1.default.ASSET_CUSTOMFIELD_8,
        fieldType: BasicFieldType_1.default.STRING,
        propertyName: 'customField8',
        label: () => lib_i18n_1.default.t('last-service'),
        sortable: false,
        width: 100,
        gqlFields: 'customField8',
    },
    [ViewFieldKey_1.default.ASSET_CUSTOMFIELD_9]: {
        key: ViewFieldKey_1.default.ASSET_CUSTOMFIELD_9,
        fieldType: BasicFieldType_1.default.STRING,
        propertyName: 'customField9',
        label: () => lib_i18n_1.default.t('last-service'),
        sortable: false,
        width: 100,
        gqlFields: 'customField9',
    },
};
exports.default = exports.AssetViewFields;
